export default __webpack_public_path__ + "static/media/francois-hoang-xxZCfAnMUrM-unsplash-medium.34ccb269.jpg";